// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "footer_wrapper-2hPyt";
var _4 = "checkboxes_wrapper-2PtqU";
export { _1 as "__esModule", _2 as "mobile", _3 as "footer_wrapper", _4 as "checkboxes_wrapper" }
export default { "__esModule": _1, "mobile": _2, "footer_wrapper": _3, "checkboxes_wrapper": _4 }
